// src/pages/TicketRecall/QrScanRecall/index.tsx
// Mục 8.3 (README_UPDATE.md) — Thu hồi vé bằng đọc mã QR qua ảnh. Dùng chung component
// QrScanSessionPage với scanType = 2 (Thu hồi).
import React from 'react';
import QrScanSessionPage from 'pages/TicketScan/QrScanSessionPage';

const QrScanRecallPage: React.FC = () => <QrScanSessionPage scanType={2} />;

export default QrScanRecallPage;
